/* Song Compatibility Checker
   Vanilla JS, no dependencies, no build step (requires modern browser — no IE11)
   Reads config from window.SongCheckerConfig[sectionId] set by Liquid
*/
(function () {
  'use strict';

  function init() {
    var configs = window.SongCheckerConfig || {};
    Object.keys(configs).forEach(function (sectionId) {
      initSection(configs[sectionId]);
    });
  }

  function initSection(config) {
    var id = config.sectionId;
    var ytKey = config.ytKey;

    var input    = document.getElementById('song-checker-input-' + id);
    var btn      = document.getElementById('song-checker-btn-' + id);
    var dropdown = document.getElementById('song-checker-dropdown-' + id);

    if (!input || !btn || !dropdown) return;

    var selectedSong = null;
    var debounceTimer = null;

    // Debounced search on input
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      selectedSong = null;
      btn.disabled = true;

      var q = input.value.trim();
      if (q.length < 2) {
        hideDropdown(dropdown);
        return;
      }

      debounceTimer = setTimeout(function () {
        searchYouTube(q, ytKey, function (items) {
          renderDropdown(items, dropdown, input, btn, function (song) {
            selectedSong = song;
          });
        });
      }, 300);
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#song-checker-' + id)) {
        hideDropdown(dropdown);
      }
    });

    // Expose selectedSong for Task 5 via custom event
    btn.addEventListener('click', function () {
      if (selectedSong) {
        var analyzeEvent = new CustomEvent('song-checker:analyze', {
          detail: { sectionId: id, song: selectedSong }
        });
        document.dispatchEvent(analyzeEvent);
      }
    });
  }

  // --- YouTube search ---

  function searchYouTube(query, apiKey, callback) {
    if (!apiKey) {
      callback([]);
      return;
    }
    var url = 'https://www.googleapis.com/youtube/v3/search'
      + '?part=snippet'
      + '&type=video'
      + '&videoCategoryId=10'
      + '&maxResults=5'
      + '&q=' + encodeURIComponent(query)
      + '&key=' + encodeURIComponent(apiKey);

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var items = (data.items || []).map(function (item) {
          return {
            videoId:   item.id.videoId,
            title:     decodeHtmlEntities(item.snippet.title),
            channel:   decodeHtmlEntities(item.snippet.channelTitle),
            thumbnail: (item.snippet.thumbnails.default || {}).url || ''
          };
        });
        callback(items);
      })
      .catch(function () { callback([]); });
  }

  // --- Artist/song title parsing from YouTube video title ---

  // Strip common YouTube decorations: [Official Music Video], (Audio), (Lyrics), etc.
  function stripDecorations(title) {
    return title
      .replace(/\s*[\[\(][^\[\]()]*\b(official|music video|video|audio|lyric|lyrics|hd|hq|4k|mv|m\/v|visualizer|acoustic|live|karaoke|remaster|remastered|radio|edit|version|explicit|clean|full|album)\b[^\[\]()]*[\]\)]/gi, '')
      .trim();
  }

  function parseTitle(rawTitle, channel) {
    // Common separators in YouTube music video titles
    var seps = [' - ', ' \u2013 ', ' \u2014 ', ' \u00b7 ', ' | '];
    for (var i = 0; i < seps.length; i++) {
      var idx = rawTitle.indexOf(seps[i]);
      if (idx > 0) {
        var left  = stripDecorations(rawTitle.substring(0, idx).trim());
        var right = stripDecorations(rawTitle.substring(idx + seps[i].length).trim());
        // YouTube official/VEVO channels put Artist first: "Eminem - Rap God"
        // Detect by checking if channel name matches the left side
        var chanCore  = channel.toLowerCase().replace(/vevo|official|music|topic/gi, '').trim();
        var leftLower = left.toLowerCase();
        if (chanCore.length > 1 &&
            (leftLower.indexOf(chanCore) !== -1 || chanCore.indexOf(leftLower) !== -1)) {
          return { song: right, artist: left };
        }
        return { song: left, artist: right };
      }
    }
    // Fallback: full title = song, channel name = artist
    return { song: stripDecorations(rawTitle), artist: channel };
  }

  // --- Dropdown rendering ---

  function renderDropdown(items, dropdown, input, btn, onSelect) {
    dropdown.innerHTML = '';

    if (!items.length) {
      hideDropdown(dropdown);
      return;
    }

    items.forEach(function (item) {
      var parsed = parseTitle(item.title, item.channel);
      var li = document.createElement('li');
      li.className = 'song-checker__dropdown-item';
      li.setAttribute('role', 'option');
      li.setAttribute('tabindex', '-1');

      var img = document.createElement('img');
      img.className = 'song-checker__dropdown-thumb';
      img.src = item.thumbnail;
      img.alt = '';

      var textDiv = document.createElement('div');
      textDiv.className = 'song-checker__dropdown-text';

      var titleSpan = document.createElement('span');
      titleSpan.className = 'song-checker__dropdown-title';
      titleSpan.textContent = item.title;

      var subSpan = document.createElement('span');
      subSpan.className = 'song-checker__dropdown-sub';
      subSpan.textContent = item.channel;

      textDiv.appendChild(titleSpan);
      textDiv.appendChild(subSpan);
      li.appendChild(img);
      li.appendChild(textDiv);

      li.addEventListener('click', function () {
        input.value = item.title;
        btn.disabled = false;
        hideDropdown(dropdown);
        onSelect({
          title:        parsed.song,
          artist:       parsed.artist,
          youtubeUrl:   'https://www.youtube.com/watch?v=' + item.videoId,
          displayTitle: item.title
        });
      });

      dropdown.appendChild(li);
    });

    dropdown.hidden = false;
  }

  function hideDropdown(dropdown) {
    dropdown.hidden = true;
    dropdown.innerHTML = '';
  }

  // Init when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // -------------------------------------------------------
  // Analysis + result rendering (listens for autocomplete event)
  // -------------------------------------------------------

  document.addEventListener('song-checker:analyze', function (e) {
    var id   = e.detail.sectionId;
    var song = e.detail.song;
    var config = (window.SongCheckerConfig || {})[id];
    if (!config || !config.makeUrl) return;
    runAnalysis(id, song, config.makeUrl);
  });

  function runAnalysis(id, song, makeUrl) {
    if (!makeUrl) return;
    var results = document.getElementById('song-checker-results-' + id);
    var loading = document.getElementById('song-checker-loading-' + id);
    var error   = document.getElementById('song-checker-error-' + id);
    var btn     = document.getElementById('song-checker-btn-' + id);
    if (!results || !loading || !error || !btn) return;

    // Show loading, hide previous results/error
    results.hidden = true;
    error.hidden   = true;
    loading.hidden = false;
    btn.disabled   = true;

    fetch(makeUrl, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({
        song_title:  song.title,
        artist:      song.artist,
        youtube_url: song.youtubeUrl
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        loading.hidden = true;
        renderResults(id, data, song.displayTitle);
        btn.disabled = false;
      })
      .catch(function (err) {
        console.warn('[SongChecker] analysis failed:', err);
        loading.hidden = true;
        error.hidden   = false;
        btn.disabled   = false;
      });
  }

  // --- Result rendering ---

  function renderResults(id, data, displayTitle) {
    var features      = data.features || {};
    // Handle both boolean and string "false" from Make
    var prevConverted = data.previously_converted === true || data.previously_converted === 'true';
    var score         = computeScore(features, prevConverted);

    // Score badge — conic gradient colour-coded by score
    var badge = document.getElementById('song-checker-badge-' + id);
    var pct   = (score / 5) * 100;
    var color = score >= 4 ? '#4caf73' : score >= 2.5 ? '#f0c84a' : '#e05c5c';
    badge.style.background = 'conic-gradient(' + color + ' ' + pct + '%, #e8e0d8 ' + pct + '% 100%)';

    document.getElementById('song-checker-num-' + id).textContent = score.toFixed(1);
    document.getElementById('song-checker-verdict-' + id).textContent = scoreToVerdict(score);

    var nameEl = document.getElementById('song-checker-song-name-' + id);
    nameEl.innerHTML = 'Analyzing: <strong>' + escapeHtml(displayTitle) + '</strong>';

    // Previously converted badge
    document.getElementById('song-checker-prev-' + id).hidden = !prevConverted;

    // Data point cards
    renderDataCards(id, features);

    // Show results BEFORE renderBars — bars must be in a visible subtree
    // so the setTimeout animation fires against rendered elements
    document.getElementById('song-checker-results-' + id).hidden = false;
    document.getElementById('song-checker-results-' + id).scrollIntoView({ behavior: 'smooth', block: 'nearest' });

    // Compatibility bars (after reveal)
    renderBars(id, features);
  }

  function renderDataCards(id, features) {
    var cards = [
      { label: 'Melody Type',  icon: '🎤', key: 'melody_type',
        goodValues: ['Vocal', 'Vocal / Instrumental', 'Vocal / Duet'],
        okValues:   ['Instrumental'] },
      { label: 'Instrument',   icon: '🎸', key: 'original_instrument',
        goodValues: ['Piano', 'Acoustic Guitar', 'Music Box / Piano', 'Piano / Music Box'],
        okValues:   ['Guitar / Band', 'Acoustic Guitar / Country Band'] },
      { label: 'Complexity',   icon: '🎼', key: 'complexity',
        goodValues: ['Simple'],
        okValues:   ['Medium'] },
      { label: 'Melody Line',  icon: '🎵', key: 'singable_melody',
        goodValues: ['Yes'],
        okValues:   ['Partial'] },
      { label: 'Genre',        icon: '🎸', key: 'genre',
        goodValues: [], okValues: [] },
      { label: 'Tempo',        icon: '⏱',  key: 'tempo',
        goodValues: ['Slow', 'Medium'],
        okValues:   ['Upbeat'] },
      { label: 'Polyphony',    icon: '〰️', key: 'polyphony',
        goodValues: ['Monophonic'],
        okValues:   [] }
    ];

    var grid = document.getElementById('song-checker-grid-' + id);
    if (!grid) return;
    grid.innerHTML = '';

    cards.forEach(function (card) {
      var val = features[card.key] || '—';
      var mod;
      if (card.goodValues.length === 0 && card.okValues.length === 0) {
        mod = 'ok';
      } else if (card.goodValues.indexOf(val) !== -1) {
        mod = 'good';
      } else if (card.okValues.indexOf(val) !== -1) {
        mod = 'ok';
      } else {
        mod = val === '—' ? '' : 'hard';
      }

      var div = document.createElement('div');
      div.className = 'song-checker__data-card' + (mod ? ' ' + mod : '');
      div.innerHTML =
        '<div class="song-checker__data-icon">' + card.icon + '</div>'
        + '<div class="song-checker__data-label">' + escapeHtml(card.label) + '</div>'
        + '<div class="song-checker__data-value">' + escapeHtml(val) + '</div>';
      grid.appendChild(div);
    });
  }

  function renderBars(id, features) {
    var bars = [
      { label: 'Melody Simplicity',   pct: complexityPct(features.complexity) },
      { label: 'Single-note Clarity', pct: polyphonyPct(features.polyphony) },
      { label: 'Tempo Suitability',   pct: tempoPct(features.tempo) },
      { label: 'Instrument Clarity',  pct: instrumentPct(features.original_instrument) }
    ];

    var container = document.getElementById('song-checker-bars-' + id);
    if (!container) return;
    container.innerHTML = '';

    bars.forEach(function (bar) {
      var barColor = bar.pct >= 70 ? '#4caf73' : bar.pct >= 45 ? '#f0c84a' : '#e05c5c';
      var barLabel = bar.pct >= 70 ? 'High'    : bar.pct >= 45 ? 'OK'      : 'Low';

      var row = document.createElement('div');
      row.className = 'song-checker__bar-row';
      row.innerHTML =
        '<span class="song-checker__bar-label">' + escapeHtml(bar.label) + '</span>'
        + '<div class="song-checker__bar-bg">'
        + '<div class="song-checker__bar-fill" style="background:' + barColor + '"></div>'
        + '</div>'
        + '<span class="song-checker__bar-val" style="color:' + barColor + '">' + escapeHtml(barLabel) + '</span>';
      container.appendChild(row);

      // scaleX avoids % width issues inside flex:1 containers
      (function (fillEl, pct) {
        setTimeout(function () { fillEl.style.transform = 'scaleX(' + (pct / 100) + ')'; }, 80);
      })(row.querySelector('.song-checker__bar-fill'), bar.pct);
    });
  }

  // --- Score helper functions ---

  function complexityPct(v) {
    return v === 'Simple' ? 90 : v === 'Medium' ? 60 : v === 'Complex' ? 20 : 60;
  }
  function polyphonyPct(v) {
    return v === 'Monophonic' ? 95 : v === 'Polyphonic' ? 30 : 60;
  }
  function tempoPct(v) {
    return v === 'Slow' ? 95 : v === 'Medium' ? 80 : v === 'Upbeat' ? 55 : v === 'Fast' ? 20 : 70;
  }
  function instrumentPct(v) {
    if (!v) return 65;
    var lv = v.toLowerCase();
    if (lv.indexOf('music box') !== -1 || lv.indexOf('acoustic') !== -1) return 90;
    if (lv.indexOf('piano') !== -1) return 82;
    if (lv.indexOf('full orchestra') !== -1) return 25;
    if (lv.indexOf('orchestra') !== -1) return 40;
    return 65;
  }

  function computeScore(features, prevConverted) {
    if (prevConverted) return 5.0;
    // No hummable melody = unworkable regardless of other features
    if (features.singable_melody === 'No') return 1.0;
    var score = 5.0;
    if (features.singable_melody === 'Partial') score -= 1.5;
    if (features.complexity === 'Medium')       score -= 0.5;
    else if (features.complexity === 'Complex') score -= 1.5;
    if (features.polyphony === 'Polyphonic')    score -= 0.5;
    if (features.tempo === 'Upbeat')            score -= 0.25;
    else if (features.tempo === 'Fast')         score -= 0.75;
    score = Math.round(score * 2) / 2;
    return Math.min(5, Math.max(1, score));
  }

  function scoreToVerdict(score) {
    if (score >= 5)   return 'Perfect fit \u2014 this song was made for a music box';
    if (score >= 4)   return 'Great choice \u2014 should convert beautifully';
    if (score >= 3)   return 'Good fit \u2014 minor adjustments may be needed';
    if (score >= 2)   return 'Challenging \u2014 possible but may require adaptation';
    return 'Very difficult \u2014 may not convert well';
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function decodeHtmlEntities(str) {
    var el = document.createElement('textarea');
    el.innerHTML = str;
    return el.value;
  }
})();
